import { type Gateway, useGateway } from '@ad-lucy/gateway-provider';
import { getAppConfig } from '@modules/config/appConfig';

type MfAnalyticsConfig = {
  API_ROOT: string;
  EXPORT_URL: string;
  IMG_URL: string;
  KEYCLOAK_REALM: string;
  KEYCLOAK_URL: string;
  KEYCLOAK_CLIENT_ID: string;
  SUPPORTED_LANGUAGES: string;
  THEME_URL: string;
  THEME_DEFAULT?: string;
};

type MfAnalyticsReturnProps = {
  gateway: Gateway;
  appConfig: MfAnalyticsConfig;
};

const useMfAnalyticsConfig = (): MfAnalyticsReturnProps => {
  const gateway = useGateway();
  const appConfig = getAppConfig();

  return {
    gateway,
    appConfig: {
      API_ROOT: appConfig.API_ROOT,
      EXPORT_URL: appConfig.EXPORT_URL,
      IMG_URL: appConfig.IMG_URL,
      KEYCLOAK_REALM: appConfig.KEYCLOAK_REALM,
      KEYCLOAK_URL: appConfig.KEYCLOAK_URL,
      KEYCLOAK_CLIENT_ID: appConfig.KEYCLOAK_CLIENT_ID,
      SUPPORTED_LANGUAGES: appConfig.SUPPORTED_LANGUAGES,
      THEME_URL: appConfig.THEME_URL,
      THEME_DEFAULT: appConfig.THEME_DEFAULT,
    },
  };
};

export { useMfAnalyticsConfig };
